import { AppSwitcherModule } from '@talend/app-switcher';
import { TalendWebappConfiguration } from '@talend/context';
import {
	routerConfig as semanticRouterConfig,
	semanticSubApplication,
} from '@talend/data-quality-semantic-ee';
import dataset from '@talend/dataset';
import { cmfModule as enginesCmfModules } from '@talend/engines';
import { getFeatureFlippingModule } from '@talend/feature-flipping';
import { cmfModule as NotificationCenterModule } from '@talend/notification-center';
import getRouter from '@talend/react-cmf-router';
import containersModule from '@talend/react-containers';
import { routerConfig as ruleRouterConfig, ruleSubApplication } from '@talend/rule-core';

import { CmfModule } from '../types/cmf';
import { AboutModalModule } from './AboutModal';
import { cadSubApplication } from './CAD';
import { GuidedTourModule } from './GuidedTour';

const sagaRouterConfig = {
	...semanticRouterConfig.sagaRouterConfig,
	...dataset.routerConfig.sagaRouterConfig,
	...ruleRouterConfig.sagaRouterConfig,
};

export function getCmfModules({
	launchDarklyClientSideId,
}: TalendWebappConfiguration): CmfModule[] {
	const FeatureFlippingModule =
		launchDarklyClientSideId && getFeatureFlippingModule(launchDarklyClientSideId);

	const router = getRouter({ sagaRouterConfig });

	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return [
		{ ...router.cmfModule, RootComponent: router.RootComponent },
		containersModule,
		GuidedTourModule,
		dataset.cmfModule,
		AppSwitcherModule,
		FeatureFlippingModule,
		AboutModalModule,
		NotificationCenterModule,
		enginesCmfModules,
		semanticSubApplication.cmfModule,
		cadSubApplication.cmfModule,
		ruleSubApplication.cmfModule,
	].filter(Boolean);
}
